import type { OPSUserRoleVO } from "@/api/accounts/type";

/**
 * 生成 OPS 角色列表项唯一键
 * @param role 接口返回的角色分组
 */
export const getOpsUserRoleKey = (role: OPSUserRoleVO) =>
  `${role.orgId}-${role.systemTypeCode}-${role.roleName}`;

/**
 * 从角色分组取权限查询用 roleId
 * @param role 接口返回的角色分组
 */
export const getOpsUserRoleId = (role: OPSUserRoleVO) =>
  String(role.userRoleInfoList[0]?.roleId ?? "");
